/**
 * Positions Catalog Mapper
 */

import type { LC_PositionItem, Position } from './positions.types.ts';

/**
 * Map LC_PositionItem to Position
 */
export function mapPositionOutToModel(item: LC_PositionItem): Position {
  return {
    id: item.positionId,
    name: item.position,
  };
}
